import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

export default function AdminLayout(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Dashboard");

  React.useEffect(() => {
    const handler = () => window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  React.useEffect(() => {
    for (const r of routes) {
      if (window.location.href.includes(r.layout + "/" + r.path)) {
        setCurrentRoute(r.name);
        return;
      }
    }
    setCurrentRoute("Dashboard");
  }, [location.pathname]);

  const getActiveNavbar = () => {
    for (const r of routes) {
      if (window.location.href.includes(r.layout + r.path)) return r.secondary;
    }
    return false;
  };

  const getRoutes = (routes) =>
    routes.flatMap((prop, key) => {
      const els = [];
      if (prop.layout === "/admin") {
        els.push(<Route path={`/${prop.path}`} element={prop.component} key={key} />);
        if (prop.children) {
          prop.children.forEach((child, ci) =>
            els.push(<Route path={`/${child.path}`} element={child.component} key={`${key}-c${ci}`} />)
          );
        }
      }
      return els;
    });

  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        <main className="mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]">
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText="KAADI Admin"
              brandText={currentRoute}
              secondary={getActiveNavbar()}
              {...rest}
            />
            <div className="mx-auto mb-auto h-full min-h-[84vh] p-2 pt-5 md:pr-2">
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
              </Routes>
            </div>
            <div className="p-3"><Footer /></div>
          </div>
        </main>
      </div>
    </div>
  );
}
